import { useEffect, useState } from 'react';
import { Box, CircularProgress, Typography, Alert } from '@mui/material';

const API_URL = process.env.REACT_APP_API_URL || 'https://localhost:7001/api';

/**
 * Handles the magic link redirect: reads token + email from query params,
 * redirects the browser to the backend verify endpoint which then redirects
 * to /auth/callback with JWT tokens in the fragment.
 */
export default function MagicLinkCallback() {
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    const email = params.get('email');

    if (!token || !email) {
      setError('Invalid magic link. Please request a new one.');
      return;
    }

    // Redirect to the backend verify endpoint (GET), which will validate
    // and redirect back to /auth/callback#access_token=...
    const verifyUrl = `${API_URL}/auth/magic-link/verify?token=${encodeURIComponent(token)}&email=${encodeURIComponent(email)}`;
    window.location.href = verifyUrl;
  }, []);

  if (error) {
    return (
      <Box display="flex" alignItems="center" justifyContent="center" minHeight="100vh"
        sx={{ background: 'linear-gradient(180deg, #060912 0%, #0A0E17 50%, #0D1220 100%)' }}>
        <Box sx={{ maxWidth: 420, mx: 2, p: 5, borderRadius: 3, background: 'rgba(18, 24, 41, 0.85)', border: '1px solid rgba(255,255,255,0.08)' }}>
          <Alert severity="error" sx={{ borderRadius: 2 }}>{error}</Alert>
          <Typography variant="body2" sx={{ mt: 2, textAlign: 'center' }}>
            <a href="/" style={{ color: '#7C3AED' }}>Return to login</a>
          </Typography>
        </Box>
      </Box>
    );
  }

  return (
    <Box display="flex" alignItems="center" justifyContent="center" minHeight="100vh"
      sx={{ background: 'linear-gradient(180deg, #060912 0%, #0A0E17 50%, #0D1220 100%)' }}>
      <Box sx={{ textAlign: 'center' }}>
        <CircularProgress sx={{ color: '#7C3AED', mb: 2 }} />
        <Typography variant="body1" sx={{ color: '#E8ECF4' }}>Verifying your magic link...</Typography>
      </Box>
    </Box>
  );
}
